module.exports = __webpack_public_path__ + "static/media/Balfour-RGB_Full-Vertical-Center-ColourL.4c9ebc06.avif";